export const WMWE_URL = "https://wemeetweeat.co";
export const EASE = [0.22, 1, 0.36, 1];
export const EVENT_DATE = "2026-11-13T11:00:00-05:00";
export const VENUE = {
  name: "Spaces",
  address: "3010 Monroe Rd, Suite 203",
  city: "Charlotte, NC 28205",
};
export const TICKETS = [
  {
    id: "luncheon",
    file: "01",
    name: "The Daytime Briefing",
    day: "Friday, November 13, 2026",
    time: "11:00 AM — 3:00 PM",
    price: 115,
    note: "FRIDAY // LUNCH INCLUDED",
    capacity: 60,
    lead: "Assess your position. Identify your gaps. Gather intelligence. An immersive daytime RECON experience featuring a curated selection of voices and perspectives, meaningful conversation, and the opportunity to gather intelligence over a beautifully set table.",
    includes: [
      "The full Friday RECON experience",
      "The Intelligence Exchange",
      "The 2026 RECON Field Guide",
      "Lunch",
    ],
    full: [
      "Assess your position. Identify your gaps. Gather intelligence.",
      "Join us for an immersive daytime RECON experience featuring a curated selection of voices and perspectives, meaningful conversation, and the opportunity to gather intelligence over a beautifully set table.",
      "Experience the RECON journey, participate in The Intelligence Exchange, and receive the 2026 RECON Field Guide — all while connecting with women who understand that important moves deserve intelligence.",
      "Your Daytime Briefing ticket includes the full Friday experience and lunch.",
    ],
  },
  {
    id: "supper",
    file: "02",
    name: "The Last Supper",
    day: "Saturday, November 14, 2026",
    time: "7:00 PM — 10:00 PM",
    price: 175,
    note: "SATURDAY EVENING // CANDLELIT",
    capacity: 10,
    lead: "Some intelligence is gathered in the room. Some of it is revealed at the table. An intimate, candlelit dinner built around meaningful conversation, prayer, music, wisdom, and the kind of connection that can only happen when the right women gather around the table.",
    includes: [
      "An intimate candlelit dining experience",
      "Dinner, music + prayer",
      "Meaningful conversation + connection",
      "The 2026 RECON Field Guide",
      "A special RECON gift",
    ],
    full: [
      "Some intelligence is gathered in the room. Some of it is revealed at the table.",
      "As the evening settles, join us for an intimate, candlelit dinner built around meaningful conversation, prayer, music, wisdom, and the kind of connection that can only happen when the right women gather around the table.",
      "This is where the RECON experience slows down. Where conversations go deeper. Where stories are exchanged. Where perspective shifts. And where wisdom has room to surface.",
      "Because not everything you need will come from a stage. Sometimes, what you've been looking for is sitting across the table from you.",
      "The Last Supper is an evening designed for women who value meaningful connection, honest conversation, beautiful experiences, and the wisdom that can emerge when the room feels safe enough to bring your whole self.",
      "Enjoy an exceptional dinner, music, prayer, conversation, and the opportunity to connect with women who may become part of what happens next.",
      "Come expecting to connect with your next. Your next conversation. Your next connection. Your next collaborator. Your next opportunity. Your next perspective. Or perhaps — the person who helps you see your next move differently.",
      "Because you never know what intelligence may be waiting at the table.",
    ],
  },
  {
    id: "vip",
    file: "03",
    name: "The Full Briefing",
    day: "Both Days, November 13–14",
    time: "The Daytime Briefing + The Last Supper",
    price: 245,
    note: "BOTH DAYS // NOTHING MISSED",
    capacity: 20,
    best: true,
    lead: "The complete briefing requires the full experience. For the woman who doesn't want to choose between the conversations, the tables, the exchanges, or the moments in between — both days, every table, every exchange.",
    includes: [
      "The Daytime Briefing (Friday, incl. lunch)",
      "The Last Supper (Saturday dinner)",
      "The 2026 RECON Field Guide",
      "Priority seating throughout",
      "A VIP Classified Briefing — exclusive experience",
    ],
    full: [
      "The complete briefing requires the full experience.",
      "For the woman who doesn't want to choose between the conversations, the tables, the exchanges, or the moments in between.",
      "The Full Briefing gives you access to the complete RECON 2026 experience — from the intelligence gathered during the day to the conversations and connections that continue around the table after hours.",
      "Be present for both days. Experience every table. Participate in every exchange. Gather what you need. And give yourself room to discover what you didn't know you were looking for.",
      "Both days. Every table. Every exchange. Nothing held back. Nothing missed.",
      "Before your next move, gather intelligence.",
    ],
  },
];
